var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0495 3.02997L4.02953 6.95997C2.09953 8.21997 2.09953 11.04 4.02953 12.3L10.0495 16.23C11.1295 16.94 12.9095 16.94 13.9895 16.23L19.9795 12.3C21.8995 11.04 21.8995 8.22997 19.9795 6.96997L13.9895 3.03997C12.9095 2.31997 11.1295 2.31997 10.0495 3.02997Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63012 13.58L5.62012 18.27C5.62012 19.54 6.60012 20.9 7.80012 21.3L10.9901 22.36C11.5401 22.54 12.4501 22.54 13.0101 22.36L16.2001 21.3C17.4001 20.9 18.3801 19.54 18.3801 18.27V13.63",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4004 15.5V9.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.c558e6f87d3c0219c1c5913d1c4864d4.svg";
export { ForwardRef as ReactComponent };